import React, { useState, useRef, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Home.css";
import HeroImage from "../assets/brik.png";
import Carousel from "./Carousel";
import BroBro from "../assets/briksupport.jpg";
import confetti from "canvas-confetti";
import brikHome from "../assets/brik_home.png";
import phoneStand from "../assets/phonestand.png";
import utilityCard from "../assets/utility.png";
import knifeCard from "../assets/knife.png";
import brikCard from "../assets/brikcard.png";
import powerbank from "../assets/battery.png";
import brikwallet from "../assets/walletyuh.png";
import funPic from "../assets/funpic.JPG";
import bruh from "../assets/mess.webp";
import boxes from "../assets/boxes1.webp";
const Home = () => {
  // Preload images when the component mounts
  useEffect(() => {
    const images = [HeroImage, BroBro];
    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  // Newsletter state variables
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterMessage, setNewsletterMessage] = useState("");
  const newsletterRef = useRef(null);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleNewsletterSignup();
    }
  };
  // Regular expression for basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Function to handle newsletter signup
  const handleNewsletterSignup = async () => {
    if (!newsletterEmail) {
      setNewsletterMessage("Please enter an email address.");
      return;
    }
    if (!emailRegex.test(newsletterEmail)) {
      setNewsletterMessage("Please enter a valid email address.");
      return;
    }

    setNewsletterMessage("");

    const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
    const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

    try {
      const response = await fetch(
        `${SUPABASE_URL}/rest/v1/email_list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apikey: SUPABASE_KEY,
            Authorization: `Bearer ${SUPABASE_KEY}`,
            Prefer: "return=representation"
          },
          body: JSON.stringify({ email: newsletterEmail })
        }
      );

      if (response.ok) {
        setNewsletterMessage("Thank you for signing up!");
        setNewsletterEmail("");

        // Calculate the center of the newsletter box
        if (newsletterRef.current) {
          const rect = newsletterRef.current.getBoundingClientRect();
          const originX = (rect.left + rect.width / 2) / window.innerWidth;
          const originY = (rect.top + rect.height / 2) / window.innerHeight;

          // Trigger confetti effect with the origin at the center of the box
          confetti({
            particleCount: 100,
            spread: 70,
            origin: { x: originX, y: originY }
          });
        }

        // Clear the success message after 3 seconds
        setTimeout(() => {
          setNewsletterMessage("");
        }, 3000);
      } else {
        console.error("Failed to sign up:", await response.text());
        setNewsletterMessage("There was an issue signing you up. Please try again later.");
      }
    } catch (error) {
      console.error("Error signing up:", error);
      setNewsletterMessage("There was an error. Please try again later.");
    }
  };

  return (
    <div className="home">
      <Header />
      <main>
        <section className="hero">
          <div className="hero-image-wrapper">
            <img
              src={brikHome}
              alt="The Brik ID and Essentials"
              className="hero-image"
            />
          </div>
          <div className="hero-content">
            <h1>Keep Your Essentials</h1>
            <h1>Secure. Organized. Always.</h1>
          </div>
        </section>

        {/* Product Section */}
        <section className="products">
          <h2>Shop Our Products</h2>
          <div className="product-container">
            <div className="product-card" onClick={() => window.location.href = "/wallet"}>
              <img src={brikwallet} alt="Wallet" />
              <h3>Wallet</h3>
              <p>$39.99</p>
            </div>
            <div className="product-card" onClick={() => window.location.href = "/stand"}>
              <img src={phoneStand} alt="Phone Stand" />
              <h3>Phone Stand</h3>
              <p>$12.99</p>
            </div>
            <div className="product-card" onClick={() => window.location.href = "/card"}>
              <img src={brikCard} alt="Brik Card" />
              <h3>Brik Card</h3>
              <p>$12.99</p>
            </div>
            <div className="product-card" onClick={() => window.location.href = "/powerbank"}>
              <img src={powerbank} alt="Powerbank" />
              <h3>Power Bank</h3>
              <p>$20.99</p>
            </div>
            <div className="product-card" onClick={() => window.location.href = "/knife"}>
              <img src={knifeCard} alt="Foldable Knife" />
              <h3>Foldable Knife</h3>
              <p>$15.99</p>
            </div>
            <div className="product-card" onClick={() => window.location.href = "/utility"}>
              <img src={utilityCard} alt="Utility Card" />
              <h3>Utility Card</h3>
              <p>$10.99</p>
            </div>
          </div>
        </section>
        {/* <Carousel /> */}

        <section className="business-section">
          <div className="business-image">
            <img src={boxes} alt="The Brik packaging" />
          </div>

          <div className="business-content">
            <h2>We get down to business.</h2>
            <p><strong>Free Shipping on Orders &gt;$75</strong></p>
            <p><strong>Our Guarantee</strong></p>
            <p>
              We guarantee your satisfaction by enforcing a {" "}
              <a href="/exchange&delivery">exchange policy</a>.
            </p>
            <p><strong>Something Wrong?</strong></p>
            <p>
              If we haven’t corrected a problem before you notice it, please reach out to us at:
              <a href="mailto:asray@the-brik.com" style={{ marginLeft: "5px" }}>asray@the-brik.com</a>
            </p>
            <div className="business-buttons">
              <button className="refund-button" onClick={() => window.location.href = "/exchange&delivery"}>
                Exchange Policy
              </button>
              <button className="contact-button" onClick={() => document.getElementById('contact-us').scrollIntoView({ behavior: 'smooth' })}>
                Contact Us
              </button>
            </div>
          </div>
        </section>

        <section className="about-section">
          <div className="about-content">
            <h2>Our Story</h2>
            <p>
              The Brik started with a simple idea: <strong>carry less, do more</strong>. We set out to design the ultimate <strong>pocket-sized</strong> organizer, blending <strong>functionality, durability, and style</strong> into one sleek tool.
            </p>
            <p>
              Built for <strong>students, professionals, and everyday adventurers</strong>, The Brik ensures you never fumble for essentials again. Whether it's your <strong>cards, keys, or multitools</strong>, it's all in one place—always secure, always accessible.
            </p>
            <button className="learn-more" onClick={() => window.location.href = "/about"}>
              Learn More
            </button>
          </div>

          <div className="about-image">
            <img src={funPic} alt="The Brik Story" />

            {/* Newsletter Signup */}
            <div className="newsletter" ref={newsletterRef}>
              <h3>Stay in the Loop</h3>
              <p>Sign up for exclusive updates and deals.</p>
              <div className="newsletter-input">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={newsletterEmail}
                  onKeyPress={handleKeyPress} 
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                />
                <button className="subscribe-button" onClick={handleNewsletterSignup}>
                  Sign Up
                </button>
              </div>
              {newsletterMessage && <p className="newsletter-message">{newsletterMessage}</p>}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Home;
